import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday';

dayjs.extend(isToday);

const toDayjs = (value: string | number) => {
  const date =
    typeof value === 'number'
      ? dayjs(value < 1e12 ? value * 1000 : value)
      : dayjs(value);
  return date.isValid() ? date : null;
};

/**
 * Formats a datetime compactly: time only when today, without the year within
 * the current year. Returns '—' for invalid values.
 */
export const formatDateTime = (value: string | number): string => {
  const date = toDayjs(value);
  if (!date) return '—';
  if (date.isToday()) return date.format('HH:mm:ss');
  if (date.isSame(dayjs(), 'year')) return date.format('DD.MM HH:mm:ss');
  return date.format('DD.MM.YYYY HH:mm:ss');
};